<template>
  <v-container fluid>
    <v-expansion-panel>
      <v-expansion-panel-content v-for="(p,idx) in PracticeSiteInformation" :key="idx">
        <template slot="header">
          <div>
            <v-layout row wrap>
              <v-flex xs11>
                <template v-if="p.SiteAddress">
                  <v-text-field :value="p.SiteAddress.SiteInsitutionName" readonly></v-text-field>
                </template>
                <template v-else>
                  <v-text-field value="New Practice Site" readonly></v-text-field>
                </template>
              </v-flex>
              <v-flex xs1 v-if="isAdmin || isApplicant">
                <v-tooltip bottom>
                  <template slot="activator">
                    <v-btn icon color="secondary" @click="removePracticeSiteInformations(idx)">
                      <v-icon>clear</v-icon>
                    </v-btn>
                  </template>
                  <span>Remove Practice Site</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </div>
        </template>
        <v-card>
          <Practice-SitesInfo
            :PracticeSiteInformation="p"
            :idx="idx"
            :disableFields="disableFields"
            v-on:siteUpdate="siteUpdate"
          ></Practice-SitesInfo>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-layout justify-end row wrap>
      <v-flex xs12>
        <v-btn
          absolute
          right
          color="secondary"
          @click="PracticeSiteInformation.push({SiteAddress:{}})"
        >add Practice Site</v-btn>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 md6>
        <date-picker
          label="If not currently employed by practice site, date employment will begin"
          v-model="PracticeSite.IfNotCurrentlyEmployedStartDate"
          :disabled="disableFields"
        ></date-picker>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field
          required
          :rules="[rules.FEIN]"
          v-model="PracticeSite.FEIN"
          label="FEIN:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          row
          required
          :rules="[rules.DoesitAcceptAllPatientsRegardInsuranceorAbilitytoPay]"
          v-model="PracticeSite.DoesitAcceptAllPatientsRegardInsuranceorAbilitytoPay"
          label="Does the practice site accept all patients regardless of insurance or ability to pay?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 v-if="PracticeSite.DoesitAcceptAllPatientsRegardInsuranceorAbilitytoPay ==false">
        <v-textarea
          box
          auto-grow
          name="input-7-1"
          v-model="PracticeSite.IfNoDetailedInformation"
          label="If no, provide detailed information"
          required
          :rules="[rules.IfNoDetailedInformation]"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          row
          required
          :rules="[rules.PublicEntity]"
          v-model="PracticeSite.PublicEntity"
          label="Public Entity?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="PracticeSite.PublicEntity ==true">
        <v-textarea
          auto-grow
          box
          label="If yes, type of Practice"
          v-model="PracticeSite.IfYesTypeOfPracticePublicEntity"
          requiredd
          required
          :rules="[rules.IfYesPublicEntity]"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          row
          required
          :rules="[rules.PrivateNotforProfit]"
          v-model="PracticeSite.PrivateNotforProfit"
          label="Private not-for-Profit?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="PracticeSite.PrivateNotforProfit ==true">
        <v-textarea
          required
          :rules="[rules.IfYesTypeOfPracticePrivateNonProfit]"
          auto-grow
          box
          label="If yes, type of Practice"
          v-model="PracticeSite.IfYesTypeOfPracticePrivateNonProfit"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md6 pr-4>
        <date-picker
          label="National Health Service Corps Site Approval Date"
          v-model="PracticeSite.NationalHSCorpsSiteApprovalDate"
          :readonly="disableFields"
          :rules="[rules.NHSRequired(PracticeSite.NationalHSCorpsSiteApprovalDate), rules.NationalHealthServiceDateCheck(PracticeSite.NationalHSCorpsSiteApprovalDate, PracticeSite.NHSAExpiration)]"
        ></date-picker>
      </v-flex>

      <v-flex xs12 md6>
        <date-picker
          label="Expiration"
          v-model="PracticeSite.NHSAExpiration"
          :readonly="disableFields"
          :rules="[rules.NHSRequired(PracticeSite.NHSAExpiration), rules.NationalHealthServiceDateCheck(PracticeSite.NationalHSCorpsSiteApprovalDate, PracticeSite.NHSAExpiration)]"
        ></date-picker>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          row
          required
          :rules="[rules.AnyLimitToPatinetsSiteAccepts]"
          v-model="PracticeSite.AnyLimitToPatinetsSiteAccepts"
          label="Are there any limits on patients the healthcare provider or practice site accepts?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="PracticeSite.AnyLimitToPatinetsSiteAccepts == true">
        <v-textarea
          box
          autoGrow
          name="input-7-1"
          required
          :rules="[rules.IfYesExplainSiteAccepts]"
          v-model="PracticeSite.IfYesExplainSiteAccepts"
          label="If yes, please Explain"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          row
          required
          :rules="[rules.DoesAcceptMedicareAssignment]"
          v-model="PracticeSite.DoesAcceptMedicareAssignment"
          label="Does the healthcare provider and the practice site accept Medicare assignment?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="PracticeSite.DoesAcceptMedicareAssignment == false">
        <v-textarea
          box
          required
          :rules="[rules.IfYesExplainMedicareAssignment]"
          autoGrow
          name="input-7-1"
          v-model="PracticeSite.IfYesExplainMedicareAssignment"
          label="If no, please provide additional detail:"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          row
          required
          :rules="[rules.DoesHCPSiteAcceptsMedicacisKidChipPatients]"
          v-model="PracticeSite.DoesHCPSiteAcceptsMedicacisKidChipPatients"
          label="Does the healthcare provider and the practice site accept Medicaid/KidCare CHIP patients?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="PracticeSite.DoesHCPSiteAcceptsMedicacisKidChipPatients == false">
        <v-textarea
          box
          required
          :rules="[rules.IfNoHCPSiteAcceptsMedicacisKidChipPatientsDetails]"
          autoGrow
          name="input-7-1"
          v-model="PracticeSite.IfNoHCPSiteAcceptsMedicacisKidChipPatientsDetails"
          label="If no, please provide additional detail:"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 mt-4>
        <v-textarea
          box
          required
          :rules="[rules.ListPracticeSiteBoundaries]"
          autoGrow
          name="input-7-1"
          v-model="PracticeSite.ListPracticeSiteBoundaries"
          label="List Practice Site Boundaries "
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-textarea
          box
          required
          :rules="[rules.ListPracticeSiteBoundaries]"
          autoGrow
          name="input-7-1"
          v-model="PracticeSite.PopulationCentersIncludeinPracticeArea"
          label="Population centers included in this practice area:"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-textarea
          box
          required
          :rules="[rules.ListAnyIndicatorsOfUnusuallyHighNeeds]"
          autoGrow
          name="input-7-1"
          v-model="PracticeSite.ListAnyIndicatorsOfUnusuallyHighNeeds"
          label="List any indicators of unusually high need in the service area, such as unemployment, cultural or
language differences in the community, difficulty with primary care and/or mental health access
for Medicaid/KidCare CHIP and/or Medicare clients, etc.:"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md6 pr-4>
        <v-text-field
          required
          :rules="[rules.TotalNoOfFullTimeEquEmployedinthePracticeSite]"
          v-model="PracticeSite.TotalNoOfFullTimeEquEmployedinthePracticeSite"
          label="Total number of full-time equivalent (FTE) providers employed by the practice site in the
applicant’s healthcare discipline:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <v-text-field
          required
          :rules="[rules.TotalNumberOfActivePatients]"
          v-model="PracticeSite.TotalNumberOfActivePatients"
          label="Total number of active patients at the practice site:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>




<script>
import siteAddress from './SiteAddress.vue'
import Rules from '../validation/rules'
import PracticeSiteInfo from './PracticeSite/AppAdditionalPracticeSite'
import { mapActions, mapGetters } from 'vuex'
import { authComputed } from '@state/helpers'
import DatePickerVue from './DatePicker.vue'
export default {
  name: 'PracticeSiteInformation',
  props: {
    PracticeSiteInformation: Array,
    PracticeSite: Object,
    disableFields: Boolean,
  },
  data() {
    return {
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      rules: Rules,
    }
  },
  methods: {
    removePracticeSiteInformations(idx) {
      if (this.PracticeSiteInformation.length > 1) {
        let site = this.PracticeSiteInformation.splice(idx, 1)
        if (site[0].ID && site[0].ID > 0) {
          axios
            .delete(`PracticeSiteInformation/${site[0].ID}`)
            .then((res) => {
              console.log(res.data)
            })
            .catch((err) => {
              console.log(err)
            })
        }
      }
    },
    siteUpdate(val) {
      this.PracticeSiteInformation[val.idx] = val.val
      this.$emit('input', this.PracticeSiteInformation)
    },
  },
  computed: {
    ...authComputed
  },
  components: {
    'v-SiteAddress': siteAddress,
    'Practice-SitesInfo': PracticeSiteInfo,
    'date-picker': DatePickerVue,
  },
  watch: {
    PracticeSiteInformation: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },
    PracticeSite: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },
  },
}
</script>

<style>
h1,
h3,
h2 {
  color: #616161;
}
p,
ul {
  color: #757575;
}
</style>
